import DeniedCircleIcon from '@uala/icons/DeniedCircleIcon';
import DoneCircleIcon from '@uala/icons/DoneCircleIcon';
import InfoCircleIcon from '@uala/icons/InfoCircleIcon';
import StandbyCircleIcon from '@uala/icons/StandbyCircleIcon';
import React, { ComponentProps } from 'react';

import {
  StyledNotificationContainer,
  StyledNotificationIcon,
  StyledNotificationText
} from './styles';
import NotificationPropsInterface from './types';

const icons = {
  error: DeniedCircleIcon,
  success: DoneCircleIcon,
  info: InfoCircleIcon,
  warning: StandbyCircleIcon
};

const Notification: React.FC<NotificationPropsInterface> = ({
  text,
  variant,
  children,
  ...props
}) => {
  const Icon = icons[variant];
  return (
    <StyledNotificationContainer variant={variant} role="alert" {...props}>
      <StyledNotificationIcon aria-hidden="true">
        <Icon />
      </StyledNotificationIcon>
      <StyledNotificationText>{text || children}</StyledNotificationText>
    </StyledNotificationContainer>
  );
};

export type NotificationProps = ComponentProps<typeof Notification>;
export default Notification;
